/**
 * props :
 * top_arr: arrow ontop
 * btm_arr: arrow bottom
 * let_arr: arrow left
 * right_arr: arrow right
 * left: left position of arrow
 * top: top postion of arrow
 */
import React from 'react';
import { TooltipWrapper } from './TooltipStyles';

const Tooltip = ({ children, ...props }) => (
	<TooltipWrapper className='tooltip-wrap' {...props}>{children}</TooltipWrapper>
);

export default Tooltip;
